import { FunctionComponent } from "react";

import { DATE_FORMATS, DateTime } from "@bps/date-time";
import { ChangeLogDto } from "@libs/api/types/common-dtos";

interface ComponentDateTextProps {
  changeLog: ChangeLogDto;
  // When set, shows only that date; otherwise falls back from updated to created.
  dateField?: "createdDate" | "updatedDate";
}
export const ComponentDateText: FunctionComponent<ComponentDateTextProps> = ({
  changeLog,
  dateField
}) => {
  const date = dateField
    ? changeLog?.[dateField]
    : changeLog?.updatedDate ?? changeLog?.createdDate ?? undefined;
  if (!date) return <>-</>;
  return (
    <>{DateTime.fromISO(date).toFormat(DATE_FORMATS.DETAILED_DATE_TIME)}</>
  );
};
